const IBAN_REGEX =
  /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/i

export const isIbanValid = (iban: string): boolean => {
  const cleanIban = iban.replace(/[\s-]+/g, '')
  if (!IBAN_REGEX.exec(cleanIban)) {
    return false
  }
  const internalStr = cleanIban.slice(3) + cleanIban.slice(0, 4)
  let validationString: string = ''
  for (let n: number = 1; n < internalStr.length; n++) {
    const c = internalStr.charCodeAt(n)

    if (c >= 65 && c <= 90) {
      validationString += (c - 55).toString()
    } else if (c >= 48 && c <= 57) {
      validationString += internalStr[n]
    }
  }
  while (validationString.length > 2) {
    const part = validationString.slice(0, 6)
    validationString = `${parseInt(part, 10) % 97}${validationString.slice(part.length)}`
  }
  return parseInt(validationString, 10) % 97 === 1
}
